/* eslint-disable */
/**
 * @file tool基础工具类
 * Created by liuyanan06 on 2018/11/24.
 */
const util = {};
util.$ = function (query, context) {
    return (context || document).querySelector(query);
};

util.trim = (function () {
    var trimReg = /(^\s*)|(\s*$)/g;
    return function (s) {
        if (!s || typeof s !== 'string') {
            return s;
        }
        return s.replace(trimReg, '');
    };
})();

util.startWith = function (str, startStr) {
    if (!str || !startStr || str.length == 0 || startStr.length > str.length) return false;
    if (str.substr(0, startStr.length) == startStr) return true;
    else return false;
};
util.endWith = function (str, endStr) {
    if (!str || !endStr || str.length == 0 || endStr.length > str.length) return false;
    if (str.substr(str.length - endStr.length) == endStr) return true;
    else return false;
};

/**
 * type check
 */
util.isBlank = function (obj) {
    return obj === undefined || obj === null || util.trim(obj) === '';
};

util.isNull = function (o) {
    return !o && o !== false && o !== 0;
};

/**
 * 获取一个object的真实类型，如function(){}就是Function、{}是Object
 */
util.objectType = (function () {
    var objectTypeReg = /^\[object (.*)\]$/;
    return function (obj) {
        if (typeof obj == 'object' || typeof obj == 'function') {
            return Object.prototype.toString.call(obj).match(objectTypeReg)[1];
        } else {
            return undefined;
        }
    };
})();

/**
 * nativeAppAdapter内部使用的次数函数
 */
util.internalUnique = (function () {
    var time = 0;
    return function () {
        // return ++time;
        return +new Date();
    };
})();
/**
 * unique，计数器,每次叠加一
 */
util.unique = (function () {
    var time = 0;
    return function () {
        return ++time;
    };
})();

/**
 * 获取script脚本
 * @param url: script url or a object{url,success,error,timeout}
 * @param sucess: onload callback
 * @param error: onerror callback
 * @param timeout: millisecond && type: number
 * @param onetime: 请求结束后是否删除该script标签
 * @param notime: 不携带时间戳
 */
util.getScript = function (url, success, error, timeout, onetime, notime) {
    if (util.objectType(url) == 'Object') {
        success = url.success;
        error = url.error;
        timeout = url.timeout;
        onetime = url.onetime;
        notime = url.notime;
        url = url.url;
    }
    var script = document.createElement('script'),
        resulted = false,
        onload = function () {
            if (resulted) {
                return;
            }
            resulted = true;
            if (util.objectType(success) == 'Function') {
                success.call(window);
            }
            if (onetime) {
                script.removeEventListener('load', onload);
                script.removeEventListener('error', onerror);
                document.body.removeChild(script);
            }
        },
        onerror = function () {
            if (resulted) {
                return;
            }
            resulted = true;
            if (util.objectType(error) == 'Function') {
                error.call(window);
            }
            script.removeEventListener('load', onload);
            script.removeEventListener('error', onerror);
            document.body.removeChild(script);
        };

    script.addEventListener('load', onload);
    script.addEventListener('error', onerror);
    if (!notime) {
        url = util.appendParam(url, '_naat=' + util.internalUnique());
    }
    script.setAttribute('src', url);
    document.body.appendChild(script);

    if (timeout) {
        setTimeout(function () {
            onerror.call(window);
        }, timeout);
    }
};

/**
 * jsonp method
 * @type {RegExp}
 */
util.getJsonp = function (url, data, success, error, timeout, notime) {
    if (util.objectType(url) == 'Object') {
        data = url.data;
        success = url.success;
        error = url.error;
        timeout = url.timeout;
        notime = url.notime;
        url = url.url;
    }
    url = util.appendParam(url, data);
    url = util.appendCallback(url, success);
    util.getScript(url, undefined, error, timeout || 5000, true, notime);
};

/**
 * 向url追加参数，处理向url添加参数?和&的问题
 * param: string or object
 */
util.appendParam = function (url, param) {
    if (util.isNull(param)) {
        return url;
    }
    if (util.objectType(param) == 'Object') {
        param = util.stringifyObject(param);
    }
    if (!url) {
        url = '';
    }
    let urlArr = url.split('#/');
    url = urlArr[0];
    if (util.endWith(url, '?')) {
        url += param;
    } else if (util.endWith(url, '&')) {
        if (url.indexOf('?') >= 0) {
            url += param;
        } else {
            url += '?' + param;
        }
    } else {
        if (url.indexOf('?') >= 0) {
            url += '&' + param;
        } else {
            url += '?' + param;
        }
    }
    urlArr[0] = url;
    // 如果有多个#/ 直接保持原url的格式不作处理
    url = urlArr.join('#/');
    return url;
};

/**
 * 向url添加callback
 */
util.appendCallback = (function () {
    var callbackReg = /(&|\?)callback=([^&]*)?(&|$)/g;
    return function (url, fn, clear) {
        if (util.objectType(fn) != 'Function' || util.isBlank(url)) {
            throw new Error("callback function should be a function and url can't be blank.");
        }
        // clear默认true 回调一次后清除
        clear !== false && (clear = true);
        var callbackName = 'naaInternalCallback' + util.internalUnique();
        window[callbackName] = function (data) {
            fn.call(window, data);
            if (clear === true) {
                delete window[callbackName];
            }
        };
        var result = url;
        //callback
        if (url.search(callbackReg) >= 0) {
            result = url.replace(callbackReg, function (match, begin, value, end) {
                return begin + 'callback=' + callbackName + end;
            });
        } else {
            result = util.appendParam(url, 'callback=' + callbackName);
        }

        return result;
    };
})();

/**
 * convert Object to "a=1&b=2" liked String
 * @param obj
 * @returns "a=1&b=2" liked
 */
util.stringifyObject = function (obj) {
    if (util.objectType(obj) !== 'Object') {
        if (util.isBlank(obj) || typeof obj !== 'string') {
            return '';
        }
        return obj;
    }
    var r = '';
    util.hasOwn(obj, function (key, value) {
        r += '&' + key + '=' + encodeURIComponent(value);
    });
    return r.substr(1);
};

/**
 * convert "a=1&b=2" liked String to Object
 * @param obj
 * @returns {*}
 */
util.parseStringifiedObject = function (str) {
    if (typeof str !== 'string') {
        if (typeof str == 'object') {
            return str;
        }
        return {};
    }

    var r = {},
        strArr = str.split('&'),
        len = strArr.length,
        i,
        t,
        p,
        k,
        v;
    for (i = 0; i < len; i++) {
        t = strArr[i];
        p = t.indexOf('=');
        if (p <= 0) {
            continue;
        }
        k = t.substring(0, p);
        v = decodeURIComponent(t.substr(p + 1));
        r[k] = v;
    }

    return r;
};

/**
 *遍历对象的所有自有属性，执行回调函数fn(key,value)
 */
util.hasOwn = function (obj, fn) {
    var k, v;
    for (k in obj) {
        if (obj.hasOwnProperty(k)) {
            v = obj[k];
            fn && fn.call(window, k, v);
        }
    }
};

/**
 * 创建一个iframe请求
 */
util.makeIframeRequest = function (url, notime) {
    var iframe = document.createElement('iframe');
    iframe.style.cssText = 'position:absolute;top:-9999px;left:-9999px;width:0;height:0';
    iframe.id = 'naaIframeRequest' + util.internalUnique();
    iframe.setAttribute('src', util.appendParam(url, notime ? '' : '_naat=' + util.internalUnique()));
    document.body.appendChild(iframe);
    setTimeout(function () {
        document.body.removeChild(iframe);
    }, 100);
};

/**
 * 创建一个a标签请求
 */
util.makeAnchorRequest = function (url, notime) {
    location.href = util.appendParam(url, notime ? '' : '_naat=' + util.internalUnique());
    // ios有的机型不能调起地图, 这里直接用原生方式跳转
    // var a = document.createElement('a');
    // a.style.cssText = 'position:absolute;top:-9999px;left:-9999px;';
    // a.id = 'naaAnchorRequest' + util.internalUnique();
    // a.setAttribute('href', util.appendParam(url, notime ? '' : '_naat=' + util.internalUnique()));
    // document.body.appendChild(a);
    // a.click();
    // setTimeout(function () {
    //     document.body.removeChild(a);
    // }, 100);
};

/***
 *  url过滤，目前过滤字段为BDUSS、cuid
 * @param url
 * @param paramsArr: 默认是：['BDUSS', 'cuid']
 * @returns {*}
 */
util.filterUrl = function (url, paramsArr) {
    if (util.objectType(paramsArr) != 'Array') {
        paramsArr = ['BDUSS', 'cuid'];
    }

    paramsArr.forEach(function (type) {
        var reg = new RegExp('[&]*' + type + '=([^&]*)', 'ig');
        url = url.replace(reg, '');
    });
    return url;
};

//比较两个版本号的大小
util.compareSv = function (sv1, sv2) {
    if (!sv1 || !sv2 || typeof sv1 != 'string' || typeof sv2 != 'string') {
        throw new Error('sv should be a string');
    }

    var sv1s = sv1.split('.'),
        sv2s = sv2.split('.'),
        s1len = sv1s.length,
        s2len = sv2s.length,
        minlen = Math.min(s1len, s2len),
        i,
        s1,
        s2;
    for (i = 0; i < minlen; i++) {
        s1 = parseInt(sv1s[i]);
        s2 = parseInt(sv2s[i]);
        if (s1 < s2) {
            return -1;
        }
        if (s1 > s2) {
            return 1;
        }
    }

    if (s1len > s2len) {
        return 1;
    } else if (s1len < s2len) {
        return -1;
    } else {
        return 0;
    }
};
util.hasClass = function (obj, cls) {
    return obj.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
};
util.addClass = function (obj, cls) {
    if (!this.hasClass(obj, cls)) obj.className += ' ' + cls;
};
util.removeClass = function (obj, cls) {
    if (this.hasClass(obj, cls)) {
        var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
        obj.className = obj.className.replace(reg, '');
    }
};
util.toggleClass = function (obj, cls) {
    if (this.hasClass(obj, cls)) {
        this.removeClass(obj, cls);
    } else {
        this.addClass(obj, cls);
    }
};

// 获取cookie、
util.getCookie = function (name) {
    if (document.cookie.length > 0) {
        let c_start = document.cookie.indexOf(name + '=');
        if (c_start != -1) {
            c_start = c_start + name.length + 1;
            let c_end = document.cookie.indexOf(';', c_start);
            if (c_end == -1) {
                c_end = document.cookie.length;
            }
            return unescape(document.cookie.substring(c_start, c_end));
        }
    }
    return '';
};
// 设置cookie,增加到vue实例方便全局调用
util.setCookie = function (cname, value, expiredays) {
    let exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = cname + '=' + escape(value) + (expiredays == null ? '' : ';expires=' + exdate.toGMTString());
};
// 删除cookie
util.delCookie = function (name) {
    let exp = new Date();
    exp.setTime(exp.getTime() - 1);
    let cval = getCookie(name);
    if (cval != null) {
        document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString();
    }
};

export default util;
/* eslint-enable */
